
import BigAdd from './BigAdd';
import TajaKhabarCard from './TajaKhabarCard';
import BollywoodNews2 from './BollywoodNews2';
import InternationalDetails2 from './InternationalDetails2';
import { Helmet } from "react-helmet";
// import '../components/TajaKhabarDetails.css'


function TajaKhabarDetails() {
  return (
    <div>

      <Helmet>
        <title>हिंदी समाचार आज की ताज़ा खबरें हिंदी में – देश दुनिया की बड़ी खबरें | ShabdToday</title>
        <link rel="canonical" href="https://shabdtoday.com/TajaKhabar-News" />
        <meta name="viewport" content="width=device-width,minimum-scale=1,initial-scale=1" />
        <meta name="title" content="हिंदी समाचार आज की ताज़ा अपडेट – देश दुनिया की बड़ी ब्रेकिंग हिंदी में" />
        <meta name="description" content="आज की ताज़ा हिंदी खबरें पढ़ें — देश-दुनिया की हर बड़ी अपडेट, राजनीति, खेल, मनोरंजन और तकनीकी समाचार सबसे तेज़ और सटीक तरीके से अब एक ही जगह।" />
        <meta name="keywords" content="हिंदी समाचार, ताज़ा खबरें, आज की खबरें, देश दुनिया की खबरें, हिंदी न्यूज़ अपडेट, राजनीति समाचार, खेल समाचार, मनोरंजन न्यूज़, तकनीकी खबरें" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ShabdToday News" />

        {/* Open Graph Basic */}
        <meta property="og:title" content="ताज़ा खबरें हिंदी में – ब्रेकिंग न्यूज़ | ShabdToday" />
        <meta property="og:description" content="राजनीति, खेल, मनोरंजन और तकनीकी की ताज़ा खबरें — देश-दुनिया की बड़ी ब्रेकिंग न्यूज़ हिंदी में पढ़ें।" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://shabdtoday.com/TajaKhabar-News" />
        <meta property="og:image" content="https://shabdtoday.com/design/images/COVER-PAGE-NEW.webp" />

        {/* Schema Markup (Google Rich Results) */}
        {/* <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": "ताज़ा खबरें हिंदी – ShabdToday",
            "url": "https://shabdtoday.com/TajaKhabar-News",
            "description": "ShabdToday पर पढ़ें ताज़ा खबरें, आज की बड़ी ब्रेकिंग न्यूज़ और देश-दुनिया की मुख्य खबरें हिंदी में।",
            "publisher": {
              "@type": "Organization",
              "name": "ShabdToday",
              "logo": {
                "@type": "ImageObject",
                "url": "https://shabdtoday.com/design/images/logo-s.webp"
              }
            }
          })}
        </script> */}
        
      </Helmet>
      
      <div className="ak-post-wrapper" style={{ transform: "none" }}>
        <div
          className="ak-content-wrap ak-post-wrap ak-layout-style-1 clearfix ak-post-style-7 clearfix"
          style={{ transform: "none" }}
        >
          <div className="ak-container" style={{ transform: "none" }}>
            <div className="ak-content" style={{ transform: "none" }}>
              <div className="" style={{ transform: "none" }}>
                <div className='mt-2'>
                  <BigAdd />
                </div>
                <div>
                </div>
                <div>
                  <h1 className='head' style={{ color: 'crimson', marginLeft: 10 }}>
                    ताजा खबरें (हिंदी समाचार आज की ताज़ा खबरें हिंदी में)
                  </h1>

                </div>
                <div className="row" style={{ transform: "none" }}>
                  <div className="ak_column_1 col-md-9">
                    <div className="ak-article-inner">
                      <div className=''>
                        <div className="ak-block-header ak-block-header-style-5 no-tabs">
                          <div
                            className="main-wdgt"
                            id="widget-rs-4937"
                            data-vars-widget-type="home"
                            data-vars-widget-name="astrology"
                            data-vars-orderid={10}
                          >
                            <div className='mt-2 '>
                              <TajaKhabarCard />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="ak_column_ col-md-3 sidebar-column sidebar-column-primary-right sticky-sidebar"
                    style={{
                      position: "relative",
                      overflow: "visible",
                      boxSizing: "border-box",
                      minHeight: 1
                    }}
                  >
                    <div
                      className="theiaStickySidebar"
                      style={{
                        paddingTop: 0,
                        paddingBottom: 1,
                        position: "sticky",
                        transform: "none",
                        top: 0,
                        left: "914.5px"
                      }}
                    >
                      <div className="sidebar post-sidebar">
                        <BollywoodNews2 />
                        <InternationalDetails2 />
                      </div>
                      <div
                        className="resize-sensor"
                        style={{
                          position: "absolute",
                          inset: 0,
                          overflow: "hidden",
                          zIndex: -1,
                          visibility: "hidden"
                        }}
                      >
                        <div
                          className="resize-sensor-expand"

                          style={{
                            position: "absolute",
                            left: 0,
                            top: 0,
                            right: 0,
                            bottom: 0,
                            overflow: "hidden",
                            zIndex: -1,
                            visibility: "hidden"
                          }}
                        >
                          <div
                            style={{
                              position: "absolute",
                              left: 0,
                              top: 0,
                              transition: "all 0s ease 0s",
                              width: 410,
                              height: 1260
                            }}
                          />
                        </div>
                        <div
                          className="resize-sensor-shrink"
                          style={{
                            position: "absolute",
                            left: 0,
                            top: 0,
                            right: 0,
                            bottom: 0,
                            overflow: "hidden",
                            zIndex: -1,
                            visibility: "hidden"
                          }}
                        >
                          <div
                            style={{
                              position: "absolute",
                              left: 0,
                              top: 0,
                              transition: "0s",
                              width: "200%",
                              height: "200%"
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TajaKhabarDetails
